import axios from 'axios';
import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { get } from '../pages/utils/utils';

// Define the types for the context
export interface User {
  id: string;
  token: string;
}

interface AuthContextType {
  user: User;
  additionalData: Record<string, any>;
  setAdditionalData: (data: Record<string, any>) => void;
  login: (user: User) => void;
  logout: () => void;
  isLoggedIn: () => boolean;
  isAdmin: () => boolean;
}

// Create the context with an initial value of `undefined`
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Custom hook to access the AuthContext
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Define the provider component
interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User>({id: '', token: ''});
  const [additionalData, setAdditionalData] = useState<Record<string, any>>({});

  useEffect(() => {
    if(!user) {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      login(user);
    }
  }, []);

  const login = (user: User) => {
    setUser(user);
  };

  const logout = () => {
    get({
      url: 'logout.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        if(data.status == 'ok') {
          console.log('asdas');
          setUser({id: '', token: ''});
          localStorage.removeItem('user');
        }
      })
      .catch((error) => {
        console.error('Error during logout:', error);
      });

  };

  const isLoggedIn = (): boolean => {
    return user !== null && user !== undefined && !!user.id && !!user.token;
  };

  const isAdmin = (): boolean => {
    return user !== null && user !== undefined && user.id === '1';
  }

  return (
    <AuthContext.Provider value={{ user, additionalData, setAdditionalData,  login, logout, isLoggedIn, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};
